import { Noise } from './Noise';
import { StaticLightComputing } from './StaticLightComputing';
import { Viewport } from './Viewport';

export function createToolsModule(app) {
  const viewport = new Viewport(app);
  const staticLightComputing = new StaticLightComputing(app);
  const noise = new Noise();

  return {
    viewport,
    noise,
    staticLightComputing,
  };
}
